export default __webpack_public_path__ + "static/media/11-66.1bbdac30.png";